import {Button, Card, Space, Typography,} from "antd";
import {ArrowLeftOutlined, EnvironmentOutlined,} from "@ant-design/icons";
import {URLS} from "@/lib/urls";
import {Link, useSearchParams} from "react-router-dom";

const {Title, Text} = Typography;

export default function MapSelectionBanner() {

    const [searchParams, setSearchParams] = useSearchParams();


    return (
        <Card
            className="mb-6 overflow-hidden rounded-[20px] border-0 bg-gradient-to-br from-[#1677ff] to-[#69b1ff] "

        >
            <div className="flex flex-wrap items-center justify-between gap-6">
                <div className="min-w-[280px] flex-1">
                    <Space direction="vertical" size={8}>
                        <Title level={3} className="!m-0 !text-white">
                            📍 کلاس خودت رو روی نقشه پیدا کن
                        </Title>

                        <Text className="text-base !text-white/90">
                            نزدیک‌ترین کلاس‌ها را روی نقشه ببین و راحت‌تر انتخاب کن.
                        </Text>
                        <Link to={URLS.student.lessons.map + '?' + searchParams.toString()}>
                            <Button
                                type="primary"
                                size="large"
                                icon={<EnvironmentOutlined/>}
                                className="mt-3 h-12 rounded-xl !border-0 !bg-white !font-semibold !text-[#1677ff]"
                            >
                                انتخاب از روی نقشه
                                <ArrowLeftOutlined/>
                            </Button>
                        </Link>

                    </Space>
                </div>

                <div
                    className="hidden md:flex h-[120px] w-[180px] overflow-hidden rounded-2xl shadow-[0_10px_30px_rgba(0,0,0,0.15)]">
                    <img
                        src="/images/map/map-preview-v3.svg"
                        alt="map preview"
                        className="h-full w-full object-cover"
                    />
                </div>
            </div>
        </Card>
    );
}